<script>
import ModelCreate from "../models/create-v2";
import FormsModel from "@/components/forms/user";
import { serialize } from "object-to-formdata";

export default {
  extends: ModelCreate,
  page: {
    title: "Create JALA Trade Users",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('users.singular')) }},
    resourceRoute: {default: 'users'},
    modelVariable: {default: 'user'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('users.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('users.plural')),
          href: "/users",
        },
        {
          text: this.$t("Create New"),
          href: "/users/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    getModelName(value) {
      return (value.user || {}).email || this.getModelKey(value)
    },
    storex(value) {
      const { user: { avatar, ...user } } = value
      return this.$axios.post('jala/investor_users', {
        ...value,
        user: {
          ...user,
          send_email_verification: !user.email_verified
        },
        redirect: `${window.location.origin}/verify_email/success`
      }).then((response) => {
        const { data: { data } } = response;
        const files = {};
        if (avatar && typeof avatar !== 'string') files.avatar = avatar;
        const promises = [];
        if (!this.lodash.isEmpty(files)) {
          promises.push(
            this.$axios.post(`jala/investor_users/${data.id}`, (
              serialize({ user: { id: data.user_id, ...files }, _method: 'PUT' })
            )).catch(() => {})
          );
        }
        if (value.user && value.user.position && data.user_id) {
          promises.push(
            this.$axios.patch(`/users/by_jala/${data.user_id}`, {
              position: value.user.position
            }).catch(() => {})
          );
        }
        return Promise.all(promises).then(() => response);
      })
    },
    store(value) {
      return this.$axios
        .post('/users', value)
        .catch((e) => {
          if (e.response && e.response.data) {
            this.errors = e.response.data.errors;
          }
          throw e
        });
    }
  }
}
</script>
